import { useForm } from 'react-hook-form';

import { Button, Input, Spinner } from '@ui';

import { form } from './LayoutPresetModal.css';

export type LayoutFormData = { name: string };

type NewLayoutFormProps = {
    onCancel: () => void;
    onSave: (data: LayoutFormData) => void;
    isLayoutSavePending?: boolean;
};

export const NewLayoutForm = ({ onCancel, onSave, isLayoutSavePending }: NewLayoutFormProps) => {
    const { handleSubmit, register } = useForm<LayoutFormData>();
    return (
        <form onSubmit={handleSubmit(onSave)} className={form}>
            <Input
                {...register('name', {
                    required: 'Layout name is required.',
                    minLength: {
                        value: 4,
                        message: 'Layout name must be at least 4 characters.',
                    },
                })}
                size="large"
                font="h2"
                required
                placeholder="Enter layout name"
                overlay={
                    <>
                        <Button variant="plain" rounded onClick={onCancel} type="button">
                            Cancel
                        </Button>
                        <Button variant="tertiary" rounded type="submit" isDisabled={isLayoutSavePending}>
                            {isLayoutSavePending ? <Spinner size="s" /> : 'Save'}
                        </Button>
                    </>
                }
            ></Input>
        </form>
    );
};
